import { RouterOutlet } from '@angular/router';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { LanguageCode, LanguageService } from '@aando/core';
import { Language, TranslateService } from '@ngx-translate/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzSpaceModule } from 'ng-zorro-antd/space';

@Component({
  selector: 'app-layout-auth',
  imports: [
    RouterOutlet,
    CommonModule,
    NzGridModule,
    NzFlexModule,
    NgOptimizedImage,
    NzSpaceModule,
  ],
  templateUrl: './layout-auth.component.html',
  styleUrls: ['./layout-auth.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutAuthComponent {
  languageService = inject(LanguageService);
  translateService = inject(TranslateService);

  readonly selectedLang = signal<string>(this.languageService.currentLanguage);

  changeLang(language: LanguageCode): void {
    this.languageService.setLanguage(language);
    this.selectedLang.set(language);
  }
}
